const DOMAIN_SANDBOX = 'app.sandbox.nteaser.com';
const DOMAIN_LIVE = 'app.nteaser.com';

const defaults = {
  BASE_URL: 'http://localhost:3000',
  API_BASE_URL: 'http://localhost:8055',
  ASSETS_BASE_URL: 'http://localhost:8055/assets',
  TEASER_FOLDER_ID: '30c5579a-0211-4ff5-a0c0-7082b1af40b0',
  ATTACHMENTS_FOLDER_ID: '59e633a5-a4f5-4d5e-b501-905291109c74',
  OFFERS_FOLDER_ID: '311bb47b-1450-4c80-8157-053103a07c99',
  AVATAR_FOLDER_ID: '69b774b4-3b79-49bd-a834-af19de761c22',
  LOGO_FOLDER_ID: '5f04742b-23af-482c-a5fc-597fb51bc8a2',
  GA_MEASUREMENT_ID: 'G-7XPBXWCMGG',
  STRIPE_PRICING_TABLE_ID: 'prctbl_1P2G6UEuA4eYLSbCp8WW754C',
  STRIPE_PUBLISHABLE_KEY:
    'pk_live_51OOgSZEuA4eYLSbCBY0z8Vg34E3zepFSdQxlCgyrECvmcIwQ5kFMUWzter3Dzgx4lNOvjGk9Gohdwd1z3qKJHkoV0004IJwWjM',
  SENTRY_DSN: 'https://3874f4b24c8293fe86e05d55f627157b@o4508001278033920.ingest.de.sentry.io/4508001452097616',
  SENTRY_ENABLED: true,
};

const variables = {
  development: {
    ...defaults,
    API_BASE_URL: 'https://directus.sandbox.nteaser.com',
    ASSETS_BASE_URL: 'https://directus.sandbox.nteaser.com/assets',
    SENTRY_ENABLED: false,
    SENTRY_ENVIRONMENT: 'local',
    SENTRY_PROPAGATION_TARGETS: [/^https:\/\/directus\.sandbox\.nteaser\.com/],
    NTEASER_TTCC_PDF: '71ef9c0a-f673-4946-8de4-69c21e67b1e9',
    NDA_FOLDER_ID: '0cf23efa-2e0e-427f-a271-63ebb615efc0',
    TURNSTILE_SITE_ID: '0x4AAAAAACBZk8HO7ASN_M0I'
  },
  sandbox: {
    ...defaults,
    BASE_URL: 'https://app.sandbox.nteaser.com',
    API_BASE_URL: 'https://directus.sandbox.nteaser.com',
    ASSETS_BASE_URL: 'https://directus.sandbox.nteaser.com/assets',
    GA_MEASUREMENT_ID: 'G-7XPBXWCMGG',
    SENTRY_ENVIRONMENT: 'sandbox',
    SENTRY_PROPAGATION_TARGETS: [/^https:\/\/directus\.sandbox\.nteaser\.com/],
    NTEASER_TTCC_PDF: '71ef9c0a-f673-4946-8de4-69c21e67b1e9',
    NDA_FOLDER_ID: '0cf23efa-2e0e-427f-a271-63ebb615efc0',
    TURNSTILE_SITE_ID: '0x4AAAAAACBZk8HO7ASN_M0I'
  },
  live: {
    ...defaults,
    BASE_URL: 'https://app.nteaser.com',
    API_BASE_URL: 'https://directus.nteaser.com',
    ASSETS_BASE_URL: 'https://directus.nteaser.com/assets',
    GA_MEASUREMENT_ID: 'G-89M5XV4BHG',
    SENTRY_ENVIRONMENT: 'live',
    SENTRY_PROPAGATION_TARGETS: [/^https:\/\/directus\.nteaser\.com/],
    NTEASER_TTCC_PDF: 'f7fff2e1-8fb7-4a8e-a803-efc57ca91766',
    NDA_FOLDER_ID: '43db8c2e-c4d1-4683-84c7-d9fe0669e37e',
    TURNSTILE_SITE_ID: '0x4AAAAAACB-PsvxORpAE1Hj'
  },
};

const getVariables = () => {
  if (location.hostname === DOMAIN_SANDBOX) {
    return variables.sandbox;
  }

  if (location.hostname === DOMAIN_LIVE) {
    return variables.live;
  }

  return variables.development;
};

export const config = getVariables();

export const FEATURES = {
  GENERATE_TEASER: 'generate_teaser',
} as const;

export const {
  BASE_URL,
  API_BASE_URL,
  ASSETS_BASE_URL,
  TEASER_FOLDER_ID,
  ATTACHMENTS_FOLDER_ID,
  OFFERS_FOLDER_ID,
  AVATAR_FOLDER_ID,
  LOGO_FOLDER_ID,
  STRIPE_PRICING_TABLE_ID,
  STRIPE_PUBLISHABLE_KEY,
  GA_MEASUREMENT_ID,
  SENTRY_DSN,
  SENTRY_ENABLED,
  SENTRY_ENVIRONMENT,
  SENTRY_PROPAGATION_TARGETS,
  NTEASER_TTCC_PDF,
  NDA_FOLDER_ID,
  TURNSTILE_SITE_ID
} = config;
